import React, { useState, useEffect } from "react";
import Header from "./header";
import Footer from "./footer";
import AssessmentProgress from "./assessment-progress";
import Signup from "../Signup";
import Module1 from "./module1";
import CompletionPage from "./CompletionPage";
import "./style.css";

export default function Assessment() {
  const [currentView, setCurrentView] = useState('intro');
  const [showMobileWarning, setShowMobileWarning] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  
  useEffect(() => {
    // Check if user has already signed up
    const userId = localStorage.getItem('userId');
    if (userId && currentView === 'intro') {
      // User already signed up, show intro but they can skip to assessment
    }
    
    // Check screen size and device type
    const checkDevice = () => {
      const width = window.innerWidth;
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || width < 768;
      const isSmallTablet = width >= 768 && width < 1024;
      
      // Show warning for phones and small screens
      if (isMobile && width < 768) {
        setIsMobileDevice(true);
        setShowMobileWarning(true);
      } else if (isSmallTablet) {
        // Optional: warn for small tablets too
        setIsMobileDevice(false);
        setShowMobileWarning(false);
      } else {
        setIsMobileDevice(false);
        setShowMobileWarning(false);
      }
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, [currentView]);

  const handleGetStarted = () => {
    const userId = localStorage.getItem('userId');
    if (userId) {
      // User already signed up, go directly to assessment
      setCurrentView('cognitive-assessment');
    } else {
      // Show signup page first
      setCurrentView('signup');
    }
  };

  const handleSignupComplete = () => {
    setCurrentView('cognitive-assessment');
  };

  const handleAssessmentComplete = () => {
    setCurrentView('completion');
  };

  // Render different views based on currentView state
  if (currentView === 'signup') {
    return <Signup onComplete={handleSignupComplete} />;
  }

  if (currentView === 'cognitive-assessment') {
    return <Module1 onComplete={handleAssessmentComplete} />;
  }

  if (currentView === 'completion') {
    return <CompletionPage />;
  }

  // Default intro view
  return (
    <div className="assessment1-container">
      <Header />
      
      {/* Mobile Warning Modal */}
      {showMobileWarning && (
        <div className="mobile-warning-overlay">
          <div className="mobile-warning-modal">
            <div className="warning-icon">⚠️</div>
            <h2>Desktop or Tablet Required</h2>
            <p>
              The Native Brilliance Assessment requires a larger screen for optimal performance.
              Please access this assessment on a:
            </p>
            <ul>
              <li>Desktop computer</li>
              <li>Laptop</li>
              <li>Tablet (iPad or equivalent)</li>
            </ul>
            <p className="warning-note">
              <strong>Minimum screen width:</strong> 768px<br/>
              <strong>Your current screen:</strong> {window.innerWidth}px
            </p>
            <button 
              onClick={() => setShowMobileWarning(false)}
              className="warning-dismiss-btn"
            >
              I understand, continue anyway
            </button>
            <p className="warning-footer">
              For the best experience, please return on a larger device.
            </p>
          </div>
        </div>
      )}
      
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Get their <span className="highlight1">Number!</span>
        </div>
        <div className="assessment1-content">
          The following game requires you to use your cognitive skills to be a
          waiter at a busy restaurant. The goal of the game is to impress a
          guest who caught your eye. Can you get their number? Put your
          cognitive skills to the test!
        </div>

        <AssessmentProgress process={1} />

        <div onClick={handleGetStarted} className="assessment1-start-btn">
          Get started
        </div>
        
        {/* Additional mobile warning below button */}
        {isMobileDevice && (
          <div className="mobile-inline-warning">
            ⚠️ This assessment works best on larger screens
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}